import axios from 'axios'

export default {
  namespaced: true,

  state: {
    mediaList: [],
    pageMediaList: [],
    total: 0,
    current: 1,
    editId: undefined,
    editMedia: null
  },

  mutations: {
    add (state) {
      if (!state.pageMediaList[0] || state.pageMediaList[0].id) {
        state.editId = undefined
        state.editMedia = { status: 1 }
        state.pageMediaList.unshift({})
      }
    },

    cancelAdd (state) {
      state.editMedia = null
      state.pageMediaList.shift()
    },

    edit (state, { media }) {
      state.editId = media.id
      let newMedia = { ...media }
      delete newMedia._index
      delete newMedia._rowKey
      state.editMedia = newMedia
      if (!state.pageMediaList[0].id) {
        state.pageMediaList.shift()
      }
    },

    cancelEdit (state) {
      state.editId = undefined
      state.editMedia = null
    },

    replace (state, { media }) {
      const index = state.pageMediaList.findIndex(item => !item.id || item.id === media.id)
      state.pageMediaList.splice(index, 1, media)
    },

    setAll (state, { mediaList }) {
      state.mediaList = mediaList
    },

    setList (state, { mediaList, total, current }) {
      state.pageMediaList = mediaList
      state.total = total
      state.current = current
    },

    remove (state, { id }) {
      const index = state.pageMediaList.findIndex(item => item.id === id)
      state.pageMediaList.splice(index, 1)
    }
  },

  actions: {
    getAll ({ commit }) {
      return axios.get('/media').then(({ data }) => {
        commit('setAll', {
          mediaList: [...data]
        })
      })
    },

    getList ({ commit }, { current }) {
      return axios.get('/media', {
        params: {
          page: current
        }
      }).then(({ data: { data, currentPage, count } }) => {
        commit('setList', {
          mediaList: [...data],
          total: count,
          current: currentPage
        })
      })
    },

    submitAdd ({ state, commit, dispatch }) {
      const media = { ...state.editMedia }
      if (!media.timeout) {
        media.timeout = null
      }
      axios.post(`/media`, { media }).then(result => {
        if (result !== -1) {
          commit('replace', { media: result.data })
          this._vm.$Message.success('添加媒体成功')
          commit('cancelEdit')
          dispatch('getList', { current: 1 })
        }
      })
    },

    submitEdit ({ state, commit, dispatch }) {
      const media = { ...state.editMedia }
      if (!media.timeout) {
        media.timeout = null
      }
      axios.put(`/media/${state.editMedia.id}`, { media }).then(result => {
        if (result !== -1) {
          commit('replace', { media: result.data })
          this._vm.$Message.success('更新媒体成功')
          commit('cancelEdit')
          dispatch('getList', { current: state.current })
        }
      })
    },

    delete ({ state, commit, dispatch }, { media }) {
      axios.delete(`/media/${media.id}`).then(result => {
        commit('remove', { id: media.id })
        this._vm.$Message.success(result.data)
        commit('cancelEdit')
        dispatch('getList', { current: state.current })
      })
    }
  }
}
